import { pluralize } from 'humanize-plus'

const MINUTE = 60 * 1000
const HOUR = 60 * MINUTE

export const humanizeDelay = (value) => {
  const number = value / (_.isInteger(value / HOUR) ? HOUR : MINUTE)
  const unit = _.isInteger(value / HOUR) ? 'hour' : 'minute'
  return `${number} ${pluralize(number, unit)}`
} 



// WEBPACK FOOTER //
// ./src/scripts/components/EmailTemplateModal/utils.js